export function abbreviateText(text, maxLength = 250) {
    let returnString = '';
    let isShortened = false;

    if (text && text.length > 0) {
        if (text.length < maxLength) {
            returnString = text;
            isShortened = false;
        } else {
            if (text.length < maxLength ||
                text.indexOf(' ', maxLength) === -1) {
                returnString = text + '...';
            } else {
                returnString = text.substring(0, text.indexOf(' ', maxLength)) + '...';
            }
            isShortened = true;
        }
    }
    return { returnString, isShortened };
}